import { reports } from "./reports";

export const reserveV2 = {
	title: "Configuración de reserva",
	description:
		"Descripción sucinta de la página con hasta 100 caracteres. No alterar tamaño de este campo.",
	mainTabs: {
		management: "Gestión",
		reports: "Informes",
		configurations: "Configuraciones",
		loading: "Cargando...",
		disabledTooltip: "Configure las reglas de reserva primero",
	},
	sideMenu: {
		title: "Configuración de reserva",
		reserveRules: {
			title: "Reglas de reservas",
			description: "Configure ventana de intervalo y tolerancia",
		},
		roomsAndSchedule: {
			title: "Salones y horario",
			description: "Cree y edite salones, horario y mesas para reservas",
		},
		shifts: {
			title: "Turnos",
			description: "Configure turnos para facilitar operación de reservas",
		},
		specialDates: {
			title: "Fechas especiales",
			description: "Configure fechas con horarios diferenciados",
			emptyState: {
				title: "Todavía no hay nada aquí.",
				description:
					"Configure las fechas en las que el horario será diferente al estándar.",
			},
			loading: "Cargando fechas especiales...",
			error: "Error al cargar fechas especiales:",
			newDateButton: "Nueva fecha",
			filters: {
				roomPlaceholder: "Filtrar por salón",
				allRooms: "Todos los salones",
				periodPlaceholder: "Filtrar por período",
				today: "Hoy",
				thisWeek: "Esta semana",
				thisMonth: "Este mes",
				thisQuarter: "Este trimestre",
			},
			table: {
				date: "Fecha",
				title: "Título",
				startTime: "Hora de inicio",
				endTime: "Hora de fin",
				room: "Salón",
			},
			actions: {
				edit: "Editar",
				delete: "Eliminar",
			},
			notifications: {
				deleted: {
					title: "Fecha especial eliminada",
					message: "La fecha especial fue eliminada con éxito.",
				},
				deleteError: {
					title: "Hubo un problema",
					message: "No se pudo eliminar la fecha especial. Inténtelo de nuevo más tarde.",
				},
			},
			drawer: {
				newTitle: "Nueva fecha especial",
				editTitle: "Editar fecha especial",
				buttons: {
					close: "Cerrar",
					create: "Crear fecha especial",
					update: "Actualizar fecha especial",
					creating: "Creando...",
					updating: "Actualizando...",
				},
			},
			form: {
				titleLabel: "Título",
				titlePlaceholder: "Ej: Noche de Sabores del Mundo",
				dateLabel: "Fecha",
				datePlaceholder: "Seleccione la fecha",
				allDaySwitch: "Marcar el día completo",
				startTimeLabel: "Hora de inicio",
				endTimeLabel: "Hora de fin",
				roomLabel: "Salón",
				roomPlaceholder: "Seleccione uno o más salones para esta fecha especial",
				validation: {
					titleRequired: "Por favor, ingrese un título",
					dateRequired: "Por favor, seleccione una fecha",
					startTimeRequired: "Por favor, ingrese la hora de inicio",
					endTimeRequired: "Por favor, ingrese la hora de fin",
					roomRequired: "Por favor, seleccione al menos un salón",
					invalidDate: "Fecha inválida",
					validationTitle: "Validación",
				},
			},
		},
		blockedDates: {
			title: "Fechas bloqueadas",
			description: "Configure fechas en las que el recinto o sala estará cerrado",
			emptyState: {
				title: "Todavía no hay nada aquí.",
				description: "Configure las fechas en las que el recinto o sala estará cerrado.",
			},
			loading: "Cargando fechas bloqueadas...",
			error: "Error al cargar fechas bloqueadas:",
			newDateButton: "Nueva fecha",
			allDay: "Día completo",
			filters: {
				roomPlaceholder: "Filtrar por salón",
				allRooms: "Todos los salones",
				periodPlaceholder: "Filtrar por período",
				today: "Hoy",
				thisWeek: "Esta semana",
				thisMonth: "Este mes",
				thisQuarter: "Este trimestre",
			},
			table: {
				date: "Fecha",
				title: "Título",
				startTime: "Hora de inicio",
				endTime: "Hora de fin",
				room: "Salón",
			},
			actions: {
				edit: "Editar",
				delete: "Eliminar",
			},
			notifications: {
				deleted: {
					title: "Fecha bloqueada eliminada",
					message: "La fecha bloqueada fue eliminada con éxito.",
				},
				deleteError: {
					title: "Hubo un problema",
					message:
						"No se pudo eliminar la fecha bloqueada. Inténtelo de nuevo más tarde.",
				},
			},
			drawer: {
				newTitle: "Nueva fecha bloqueada",
				editTitle: "Editar fecha bloqueada",
				buttons: {
					close: "Cerrar",
					create: "Crear nuevo bloqueo",
					update: "Actualizar fecha bloqueada",
					creating: "Creando...",
					updating: "Actualizando...",
				},
			},
			form: {
				titleLabel: "Título",
				titlePlaceholder: "Ej: Mantenimiento programado",
				dateLabel: "Fecha",
				datePlaceholder: "Seleccione la fecha",
				allDaySwitch: "Marcar el día completo",
				startTimeLabel: "Hora de inicio",
				endTimeLabel: "Hora de fin",
				roomLabel: "Salón",
				roomPlaceholder:
					"Seleccione uno o más salones para bloquear reservas en esta fecha",
				validation: {
					titleRequired: "Por favor, ingrese el título",
					dateRequired: "Por favor, seleccione una fecha",
					roomRequired: "Por favor, seleccione al menos un salón",
					invalidDate: "Fecha inválida",
					validationTitle: "Validación",
				},
			},
		},
		communication: {
			title: "Comunicación",
			description: "Active o desactive envío de mensajes",
			headerTitle: "Enviar SMS a clientes",
			loading: "Cargando...",
			alert: {
				costInfo: "Los mensajes enviados tienen un costo de {{cost}}/envío.",
			},
			fields: {
				reminder: "Primer contacto",
				confirmation: "Confirmación de reserva",
				dayOf: "El día de la reserva",
				late: "Retrasado",
			},
			buttons: {
				discard: "Descartar cambios",
				save: "Guardar cambios",
				saving: "Guardando...",
			},
		},
	},
	roomsContent: {
		title: "Salones",
		newRoomButton: "Nuevo salón",
		roomName: "Nombre del salón",
		roomId: "ID del salón",
	},
	shifts: {
		title: "Turnos",
		newShiftButton: "Nuevo turno",
		editShiftLabel: "Editar turno",
		deleteShiftLabel: "Eliminar turno",
		breakfast: "Desayuno",
		lunch: "Almuerzo",
		dinner: "Cena",
		emptyState: {
			title: "Todavía no hay nada aquí.",
			description: "Cree un nuevo turno para facilitar la gestión de reservas.",
		},
	},
	newShiftDrawer: {
		title: "Nuevo turno",
		shiftNameLabel: "Nombre del turno",
		shiftNamePlaceholder: "Ingrese el nombre del turno",
		startTimeLabel: "Hora de inicio",
		endTimeLabel: "Hora de fin",
		buttons: {
			close: "Cerrar",
			create: "Crear turno",
		},
		errors: {
			required: "Este campo es obligatorio",
		},
	},
	roomsAndSchedule: {
		title: "Salones",
		newRoomButton: "Nuevo salón",
		days: {
			sunday: "Domingo",
			monday: "Lunes",
			tuesday: "Martes",
			wednesday: "Miércoles",
			thursday: "Jueves",
			friday: "Viernes",
			saturday: "Sábado",
		},
		dayInitials: {
			sunday: "D",
			monday: "L",
			tuesday: "M",
			wednesday: "M",
			thursday: "J",
			friday: "V",
			saturday: "S",
		},
		timeFormat: "{{startTime}} a {{endTime}}",
		loading: "Cargando salones...",
		loadingSchedules: "Cargando horarios...",
		error: "Error al cargar salones:",
		menuItems: {
			showSchedule: "Mostrar cuadrícula de horarios",
			hideSchedule: "Ocultar cuadrícula de horarios",
			editRoom: "Editar salón",
			deleteRoom: "Eliminar salón",
		},
		notifications: {
			roomDeleted: {
				title: "Salón eliminado con éxito",
				message: "El salón fue eliminado con éxito.",
			},
			roomDeleteError: {
				title: "Hubo un problema",
				message: "Error al eliminar salón.",
			},
			loadSchedulesError: {
				title: "Error al cargar",
				message: "Error al cargar horarios del salón.",
			},
			roomCreated: {
				title: "Salón creado con éxito",
				message: "El salón fue creado con éxito.",
			},
			roomCreateError: {
				title: "Error al crear",
				message: "Error al crear salón. Inténtelo de nuevo.",
			},
			schedulesError: {
				title: "Hubo un problema",
				message:
					"Salón creado, pero hubo error al crear los horarios. Por favor, añádalos manualmente.",
			},
		},
		creatingRoom: "Creando salón...",
		creatingSchedules: "Creando horarios...",
		emptyState: {
			title: "Todavía no hay nada aquí",
			description: "Cree un nuevo salón para permitir que sus clientes hagan reservas",
			noSettingsTitle: "Configure las reglas de reserva primero",
			noSettingsDescription:
				"Necesita configurar las reglas de reserva antes de crear salones y cuadrícula de horarios",
			actionButton: "Configurar reglas de reserva",
		},
	},
	newRoomDrawer: {
		title: "Nuevo salón",
		editTitle: "Editar salón",
		buttons: {
			close: "Cerrar",
			createRoom: "Crear salón",
			saveChanges: "Guardar cambios",
		},
		sideMenu: {
			configSection: "Config del salón",
			roomData: "Datos del salón",
			schedulesByDay: "Horarios por día",
		},
		form: {
			roomDataTitle: "Datos del salón",
			roomName: {
				label: "Nombre del salón",
				placeholder: "Ingrese el nombre del salón",
			},
			roomCapacity: {
				label: "Capacidad del salón por horario",
				placeholder: "Ingrese la capacidad del salón",
			},
			activateRoom: "Activar salón para reservas",
			importSchedule: "Importar horario de otro día o salón",
		},
		replicateScheduleLabel: "Replicar horario a otros días de la semana",
		importScheduleLabel: "Importar horario de otro día o salón",
		days: {
			sunday: "Domingo",
			monday: "Lunes",
			tuesday: "Martes",
			wednesday: "Miércoles",
			thursday: "Jueves",
			friday: "Viernes",
			saturday: "Sábado",
		},
		notifications: {
			roomUpdated: {
				title: "Salón actualizado con éxito",
				message: "El salón fue actualizado con éxito.",
			},
			roomUpdateError: {
				title: "Hubo un problema",
				message: "No pudimos guardar los cambios. Inténtelo de nuevo más tarde.",
			},
			scheduleError: {
				title: "Hubo un problema",
				message: "Salón actualizado, pero hubo error al guardar algunos horarios.",
			},
		},
		dayScheduleView: {
			schedulesTitle: "Horarios de {{day}}",
			emptyState: "Ningún horario registrado",
			newScheduleButton: "Nuevo horario",
		},
		newScheduleModal: {
			title: "Nuevo horario",
			editTitle: "Editar horario",
			startTimeLabel: "Hora de inicio",
			endTimeLabel: "Hora de fin",
			scaleLabel: "Escala (minutos)",
			scalePlaceholder: "Seleccione la escala",
			scaleOptions: {
				minutes15: "15 minutos",
				minutes30: "30 minutos",
				minutes45: "45 minutos",
				minutes60: "60 minutos",
			},
			buttons: {
				cancel: "Cancelar",
				save: "Guardar",
			},
			errors: {
				startTimeRequired: "La hora de inicio es obligatoria",
				endTimeRequired: "La hora de fin es obligatoria",
				endTimeAfterStart: "La hora de fin debe ser posterior a la hora de inicio",
				scaleRequired: "La escala es obligatoria",
				scaleInvalid: "La escala debe ser 15, 30, 45 o 60 minutos",
			},
		},
	},
	reserveRulesContent: {
		loading: "Cargando configuraciones...",
		errorLoading: "Error al cargar configuraciones:",
		sections: {
			generalRules: "Reglas generales",
			reservationParameters: "Parámetros de la reserva",
			customerSite: "Sitio del cliente",
		},
		fields: {
			calendarWindow: {
				label: "Ventana de intervalo en el calendario",
				placeholder: "Ingrese los días de intervalo",
				tooltip: "Tiempo en días hacia el futuro en que sus reservas estarán abiertas.",
			},
			delayTolerance: {
				label: "Tolerancia límite de retrasos",
				placeholder: "Ingrese la tolerancia límite...",
				tooltip:
					"Tiempo en minutos en que las reservas serán canceladas automáticamente.",
			},
			peopleLimit: {
				label: "Límite de personas por reserva",
				placeholder: "Ingrese la cantidad máxima...",
				tooltip: "Cantidad máxima de personas permitida por reserva",
			},
			rulesAndConditions: {
				label: "Reglas y condiciones de reserva",
				placeholder:
					"Ingrese las reglas y condiciones de reserva que se mostrarán al cliente en el momento de la reserva",
			},
		},
		switches: {
			autoConfirm: {
				label: "Confirmación automática de reserva",
				description:
					"Sus clientes tendrán sus solicitudes de reserva confirmadas automáticamente.",
			},
			requireCPF: {
				label: "Documento de identidad obligatorio",
				description:
					"En el momento de la reserva, el cliente solo puede avanzar si proporciona un documento de identidad válido",
			},
			requireBirthDate: {
				label: "Fecha de nacimiento obligatoria",
				description:
					"En el momento de la reserva, el cliente solo puede avanzar si ingresa su fecha de nacimiento",
			},
		},
		imageUpload: {
			label: "Imagen del sitio",
			tooltip: "Suba la imagen que se utilizará en el sitio.",
			alt: "Imagen del sitio",
			changeImage: "Cambiar imagen",
			addImage: "Agregar imagen",
			hint: "Tipo de archivo .png, .jpg y .jpeg hasta 1MB",
		},
		siteUrl: {
			label: "Sitio para reservas",
			placeholder: "http://reservas.com/nombredelrestaurante",
		},
		buttons: {
			discardChanges: "Descartar cambios",
			saveChanges: "Guardar cambios",
			createSettings: "Crear configuraciones",
			saving: "Guardando...",
		},
		notifications: {
			invalidFileType: {
				title: "Tipo de archivo inválido",
				message: "Por favor, seleccione una imagen en formato .jpg, .jpeg o .png.",
			},
			fileTooLarge: {
				title: "Archivo muy grande",
				message:
					"El archivo seleccionado excede el límite de 1MB. Por favor, seleccione una imagen más pequeña.",
			},
			saveSuccess: {
				title: "Cambios guardados con éxito",
				message: "Los cambios de reglas del salón fueron guardados con éxito.",
			},
			saveError: {
				title: "Hubo un problema",
				message: "No pudimos guardar los cambios. Inténtelo de nuevo más tarde",
			},
		},
	},
	configurations: {
		title: "Configuraciones",
		description: "Configure las reglas y horarios de sus reservas",
	},
	management: {
		title: "Reservas",
		description: "Gestione sus reservas",
		editReservationsButton: "Editar reservas en masa",
		addReservationButton: "Agregar reserva",
		todayLabel: "Hoy",
		confirmedLabel: "Confirmadas",
		cancelledLabel: "Canceladas",
		waitingConfirmationLabel: "Esperando confirmación",
		forecastLabel: "Previsión",
		peopleLabel: "personas",
		remainingReservationsLabel: "Reservas restantes del mes",
		upcomingSpecialDatesLabel: "Próximas fechas especiales",
		tabs: {
			received: "Recibidas",
			accommodated: "Acomodadas",
			cancelled: "Canceladas",
		},
		statusTags: {
			waitingConfirmation: "esperando confirmación",
			confirmed: "confirmada",
			delayed: "retrasado",
			accommodated: "acomodado",
			cancelled: "cancelada",
		},
		notifications: {
			reservationCreated: {
				title: "Reserva creada con éxito",
				message: "La reserva fue creada con éxito",
			},
			reservationCreatedError: {
				title: "Error al crear reserva",
				message: "Ocurrió un error al intentar crear la reserva. Inténtelo de nuevo.",
			},
			reservationConfirmed: {
				title: "Reserva confirmada",
				message: "La reserva fue confirmada con éxito",
			},
			reservationConfirmedError: {
				title: "Error al confirmar reserva",
				message: "Ocurrió un error al intentar confirmar la reserva",
			},
			reservationCancelled: {
				title: "Reserva cancelada",
				message: "La reserva fue cancelada con éxito",
			},
			reservationCancelledError: {
				title: "Error al cancelar reserva",
				message: "Ocurrió un error al intentar cancelar la reserva",
			},
			reservationAccommodated: {
				title: "Reserva acomodada",
				message: "La reserva fue acomodada con éxito",
			},
			reservationAccommodatedError: {
				title: "Error al acomodar reserva",
				message: "Ocurrió un error al intentar acomodar la reserva",
			},
		},
		bulkActions: {
			selectedCount: "{{count}} seleccionados",
			selectAll: "Seleccionar todos ({{count}})",
			confirmReservations: "Confirmar reservas",
			cancelReservations: "Cancelar reservas",
		},
		createReservationDrawer: {
			title: "Crear reserva",
			editTitle: "Editar reserva",
			labels: {
				peopleCount: "Cantidad de personas",
				dateTime: "Fecha y hora de reserva",
				room: "Salón",
				name: "Nombre completo",
				document: "Documento",
				phone: "Celular",
				birthDate: "Fecha de nacimiento",
				occasion: "Ocasión",
				observations: "Observaciones",
			},
			placeholders: {
				peopleCount: "Seleccione la cantidad de personas",
				dateTime: "Seleccione fecha y hora",
				room: "Seleccione el salón",
				name: "Ingrese el nombre del cliente",
				document: "Ingrese el documento del cliente",
				phone: "Número de celular",
				birthDate: "DD/MM/AAAA",
				occasion: "Elija una ocasión (opcional)",
				observations: "Ingrese una observación (opcional)",
			},
			buttons: {
				close: "Cerrar",
				create: "Crear reserva",
				update: "Guardar",
				creating: "Creando...",
				saving: "Guardando...",
			},
			occasions: {
				birthday: "Cumpleaños",
				wedding: "Boda",
				graduation: "Graduación",
				romanticDinner: "Cena Romántica",
				meeting: "Reunión",
				other: "Otro",
			},
			notifications: {
				validationError: "Error de validación",
			},
			people: "personas",
			person: "persona",
			dateTimeFormat: "{{date}} a las {{time}}",
		},
		reservationDetailsDrawer: {
			title: "Detalles de la reserva",
			loading: "Cargando...",
			notFound: "Reserva no encontrada",
			createdAt: "Creado en {{date}}",
			labels: {
				observation: "Observación",
				occasion: "Ocasión",
				notInformed: "No informado",
			},
			actions: {
				close: "Cerrar",
				cancel: "Cancelar reserva",
				confirm: "Confirmar reserva",
				accommodate: "Acomodar cliente",
				edit: "Editar",
				editReservation: "Editar reserva",
				editObservation: "Editar observación",
				editOccasion: "Editar ocasión",
			},
			alerts: {
				pending: "Aún no confirmado",
				confirmedBy: "Confirmado por {{user}} el día {{date}} a las {{time}}",
			},
			table: {
				actionHeader: "ACCIÓN",
				dateTimeHeader: "FECHA Y HORA",
				actions: {
					requested: "Reserva solicitada",
					confirmed: "Reserva confirmada",
					accommodated: "Reserva acomodada",
					cancelled: "Reserva cancelada",
					statusChanged: "Estado alterado",
					confirmationSms: "SMS de confirmación",
					delaySms: "SMS de retraso",
				},
				sendSms: "Enviar SMS",
			},
			places: {
				one: "lugar",
				other: "lugares",
			},
		},
		filters: {
			searchPlaceholder: "Buscar reserva",
			statusPlaceholder: "Filtrar por estado",
			roomPlaceholder: "Filtrar por salón",
			statusOptions: {
				all: "Todos los estados",
				waiting_confirmation: "Esperando confirmación",
				confirmed: "Confirmadas",
				accommodated: "Acomodadas",
				cancelled: "Canceladas",
			},
			roomOptions: {
				all: "Todos los salones",
			},
		},
	},
	reports,
};
